<template>
    <div>
        <el-form :inline="false" style="margin-bottom: 10px;padding-top: 0px">
            <el-form-item :label="$t('pgCommon.ROLENAME')">
                <td-input @submit.native.prevent v-model="role" :placeholder="$t('pgCommon.INPUT_CONTENT')"></td-input>
                <td-button style="margin-left: 20px" :permissions="['alarmRoleSendConfig:view']" type="primary" @click="QueryData">{{ $t('pgCommon.QUERY') }}</td-button>
                <!-- <span style="float: right">
                    <span style="color: #606266">{{$t('pgCommon.SYSTEM') + '：'}}</span>
                    <el-select v-model="sysSelect">
                        <el-option v-for="item in sysData" :key="item.sId" :label="item.sName" :value="item.sSysFlg"></el-option>
                    </el-select>
                </span> -->
            </el-form-item>
            <el-form-item>
                <td-button :permissions="['alarmRoleSendConfig:alarmSendSetting']" @click="batchAdd">{{ $t('pgCommon.LOT_ADD') }}</td-button>
                <td-button :permissions="['alarmRoleSendConfig:alarmSendSetting']" @click="BatchReset">{{ $t('pgCommon.BATCH_RESET') }}</td-button>
                <td-button :permissions="['alarmRoleSendConfig:del']" @click="onClickDelUerConfig('', 'lot')">{{ $t('pgCommon.DELETE_BATCH') }}</td-button>
            </el-form-item>
        </el-form>
        <td-table
            class="table-height"
            ref="table"
            :dataSource="initData"
            :pageSize="tablePage.pageSize"
            :currentPage="tablePage.currentPage"
            :total="tablePage.total"
            @handleSizeChange="handleSizeChange"
            @currentChange="currentChange"
            @handleSelect="handleSelect"
            @handleSelectAll="handleSelect"
        >
            <el-table-column :label="$t('pgCommon.ROLENAME')" prop="resName"></el-table-column>
            <el-table-column :label="$t('pgCommon.PUSH_ALARM')" prop="eventName">
                <template scope="scope">
                    <span class="role-span" :title="scope.row.eventName">{{ scope.row.eventName }}</span>
                </template>
            </el-table-column>
            <el-table-column :label="$t('pgCommon.OPERATE')" align="center">
                <template scope="scope" :permissions="['alarmRoleSendConfig:alarmSendSetting']">
                    <td-button :permissions="['alarmRoleSendConfig:alarmSendSetting']" type="text" @click="onClickOpenSetDialog(scope.row)">{{ $t('pgCommon.CONFIG') }}</td-button>
                    <td-button :permissions="['alarmRoleSendConfig:del']" type="text" @click="onClickDelUerConfig(scope.row, 'odd')">{{ $t('pgCommon.DELETE') }}</td-button>
                </template>
            </el-table-column>
        </td-table>
        <allotDialog
            v-if="configStatus"
            :configStatus="configStatus"
            :fettle="fettle"
            :title="title"
            :name="name"
            :checkList="checkList"
            @closeDialog="closeDialog"
            @saveData="onClickSetConfig(arguments)"
        ></allotDialog>
    </div>
</template>

<script>
import allotDialog from './components/allotDialog';
import api from './assets/api';
export default {
    name: 'alarmRoleConfig',
    components: {
        allotDialog
    },
    data() {
        return {
            role: '',
            sysSelct: 'PG',
            sysData: [],
            initData: [],
            tablePage: {
                pageSize: 10,
                pageNum: 1,
                currentPage: 1,
                total: 0
            },
            configStatus: false,
            cityOptions: [],
            checkList: [],
            title: '',
            checkTable: [],
            chooseUser: [],
            fettle: '',
            name: ''
        };
    },
    mounted() {
        // this.getSysList();
        this.QueryData();
    },
    activated() {},
    methods: {
        getSysList() {
            api.getSysList('', res => {
                res.data.content.forEach((item, index) => {
                    if (res.data.statusCode === 'API-COMMON-INF-OK') {
                        if (index === 0) {
                            this.sysSelect = item.sSysFlg;
                        }
                        let obj = {
                            sId: item.sId,
                            sName: item.sName + '：' + item.sSysFlg,
                            sSysFlg: item.sSysFlg
                        };
                        this.sysData.push(obj);
                    }
                });
            });
        },
        QueryData() {
            let params = {
                roleName: this.role,
                roleType: 0,
                sSysFlg: this.sysSelct,
                currentPage: this.tablePage.currentPage,
                pageSize: this.tablePage.pageSize
            };
            api.QueryRoleList(params, res => {
                if (res.data.statusCode === 'API-COMMON-INF-OK') {
                    if (res.data.content !== null && res.data.content !== '') {
                        this.initData = res.data.content;
                        this.tablePage.total = res.data.count;
                    } else {
                        this.initData = [];
                        this.tablePage.total = 0;
                    }
                    this.checkTable = [];
                    this.chooseUser = [];
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.statusMessage
                    });
                }
            });
        },
        BatchReset() {
            if (this.checkTable.length > 0) {
                this.title = this.$t('pgCommon.SORTNAME');
                this.checkList = [];
                this.fettle = true;
                this.configStatus = true;
            } else {
                this.$message({
                    type: 'warning',
                    message: this.$t('pgCommon.PLEASE_SELECT_CONTENT')
                });
            }
        },
        handleSizeChange(val) {
            this.tablePage.pageSize = val;
            this.tablePage.currentPage = 1;
            this.QueryData();
        },
        currentChange(val) {
            this.tablePage.currentPage = val;
            this.QueryData();
        },
        handleSelect(val) {
            this.checkTable = val;
            this.chooseUser = [];
            val.forEach(item => {
                this.chooseUser.push(item.resId);
                this.checkeds = [];
            });
        },
        batchAdd() {
            this.configStatus = true;
            this.title = this.$t('pgCommon.SORTNAME');
            this.checkList = [];
            this.fettle = false;
            this.name = '';
        },
        onClickOpenSetDialog(val) {
            this.title = this.$t('pgCommon.SORTNAME');
            this.configStatus = true;
            this.name = val.resName;
            this.fettle = true;
            this.chooseUser = [];
            this.chooseUser.push(val.resId);
            if (val.eventId !== '') {
                this.checkList = val.eventId.split(',');
            } else {
                this.checkList = [];
            }
        },
        onClickSetConfig(val) {
            let params;
            if (val.length === 1) {
                params = {
                    ids: this.chooseUser,
                    eventIds: val[0],
                    type: 1 // 0用户，1角色
                };
            } else {
                params = {
                    ids: val[1],
                    eventIds: val[0],
                    type: 1 // 0用户，1角色
                };
            }
            this.configStatus = false;
            api.saveRoleAlarmSendConfig(params, res => {
                if (res.data.statusCode === 'API-COMMON-INF-OK') {
                    this.tablePage.currentPage = 1;
                    this.tablePage.pageSize = 10;
                    this.QueryData();
                }
            });
        },
        closeDialog() {
            this.configStatus = false;
        },
        onClickDelUerConfig(val, way) {
            if (way === 'lot') {
                if (this.checkTable.length === 0) {
                    this.$message({
                        type: 'warning',
                        message: this.$t('pgCommon.PLEASE_SELECT_CONTENT')
                    });
                    return;
                }
            }
            this.$confirm(this.$t('pgCommon.DELUSER'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: this.$t('pgCommon.SAVE'),
                cancelButtonText: this.$t('pgCommon.CLOSE'),
                type: 'warning'
            })
                .then(() => {
                    let arr = [];
                    if (way === 'odd') {
                        arr.push(val.resId);
                    } else {
                        this.checkTable.forEach(item => {
                            arr.push(item.resId);
                        });
                    }
                    let params = {
                        ids: arr, // 用户或角色的id集合
                        type: 1 // 类型 0用户 1角色
                    };
                    api.delUserSortConfig(params, res => {
                        if (res.data.statusCode === 'API-COMMON-INF-OK') {
                            this.$message({
                                type: 'success',
                                message: this.$t('pgCommon.DELETE_SUCCESS')
                            });
                            this.tablePage.currentPage = 1;
                            this.tablePage.pageSize = 10;
                            this.QueryData();
                        } else {
                            this.$message({
                                type: 'error',
                                message: this.$t('pgCommon.')
                            });
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.body {
    padding: 0 20px;
}
.role-span {
    width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.table-height >>> .el-table {
    height: calc(100vh - 388px) !important;
}
</style>
